var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-content[data-v-b94cc206]{width:100%;max-width:1200px}.body1[data-v-b94cc206]{height:768px;display:flex;flex-direction:row;justify-content:center;background:url(" + escape(require("../../assets/body2-bg.png")) + ") no-repeat;background-size:100% 60%}.body1 .content[data-v-b94cc206]{width:100%;max-width:1200px;height:100%;position:relative;color:#fff}.body1 .content .title[data-v-b94cc206]{font-size:38px;font-family:Adobe Heiti Std,Helvetica,Arial,sans-serif;line-height:50px;position:absolute;top:144px;right:0;letter-spacing:0}.body1 .content .desc[data-v-b94cc206]{font-size:18px;line-height:30px;font-family:ArialMT,Helvetica,Arial,sans-serif;position:absolute;top:245px;right:0;letter-spacing:0}.body1 .content .img[data-v-b94cc206]{width:50%;height:659px;position:absolute;top:75px;object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b94cc206","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index/e-body2.vue
// module id = 163
// module chunks = 0